import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './BreathView.css';

const BreathView = ({ poem, onBack }) => {
  const [wordsLoaded, setWordsLoaded] = useState(false);

  useEffect(() => {
    // Trigger word fade-in after transition
    const timer = setTimeout(() => {
      setWordsLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  // Split poem content into lines
  const lines = poem?.content?.split('\n') || [];

  return (
    <motion.div
      className="breath-view"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1.5 }}
    >
      {/* Peach background */}
      <div className="breath-background" />

      {/* Feather behind words */}
      <motion.svg
        className="breath-feather"
        viewBox="0 0 100 250"
        initial={{ y: -20, opacity: 0 }}
        animate={{
          y: [0, -10, 0],
          opacity: 0.4,
          rotate: [0, 2, -2, 0]
        }}
        transition={{
          y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
          rotate: { duration: 6, repeat: Infinity, ease: "easeInOut" }
        }}
      >
        {/* Feather quill */}
        <line x1="50" y1="230" x2="50" y2="20" stroke="#E8D5C4" strokeWidth="3" opacity="0.8"/>

        {/* Feather barbs */}
        {[...Array(15)].map((_, i) => {
          const y = 30 + i * 13;
          const leftX = 50 - (12 - Math.abs(7 - i) * 1.5);
          const rightX = 50 + (12 - Math.abs(7 - i) * 1.5);

          return (
            <g key={i}>
              <path
                d={`M 50 ${y} Q ${leftX - 5} ${y + 3}, ${leftX} ${y + 8}`}
                stroke="#E8D5C4"
                strokeWidth="2"
                fill="none"
                opacity="0.6"
              />
              <path
                d={`M 50 ${y} Q ${rightX + 5} ${y + 3}, ${rightX} ${y + 8}`}
                stroke="#E8D5C4"
                strokeWidth="2"
                fill="none"
                opacity="0.6"
              />
            </g>
          );
        })}
      </motion.svg>

      {/* Floating poem text */}
      <div className="breath-content">
        <motion.h2
          className="breath-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          {poem?.title || 'Untitled'}
        </motion.h2>

        <div className="breath-poem-container">
          {lines.map((line, index) => (
            <motion.p
              key={index}
              className="breath-line"
              initial={{ opacity: 0, y: 30 }}
              animate={wordsLoaded ? {
                opacity: 1,
                y: [0, -8, 0],
              } : { opacity: 0, y: 30 }}
              transition={{
                opacity: { delay: index * 0.3, duration: 1.5 },
                y: {
                  delay: index * 0.3 + 1.5,
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }
              }}
            >
              {line}
            </motion.p>
          ))}
        </div>

        <motion.div
          className="breath-author"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: lines.length * 0.3 + 1, duration: 1 }}
        >
          — {poem?.author || 'Anonymous'}
        </motion.div>
      </div>

      {/* Back button */}
      <motion.button
        className="breath-back-button"
        onClick={onBack}
        whileTap={{ scale: 0.95 }}
      >
        ← Back to Poems
      </motion.button>
    </motion.div>
  );
};

export default BreathView;
